export default "__VITE_ASSET__nfA3_k7h__"